console.log('Made for Adar by Benj Grolleau - https://benjamin-grolleau.fr');

import './components/_1_anim-menu-btn';
import './components/_1_split-btn';
import './components/_1_diagonal-movement';
import './components/_1_collapse';
import './components/_1_modals';
import './components/_1_pre-header';
import './components/_1_swiper-configurations';
import './components/_2_dropdown';
import './components/_3_header';
import './components/_3_hiring-btn';
import './components/_2_zone-search';
